import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-30 grid h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}